import { ecommerceObject, ecommerceProps } from "./types";

declare global {
  interface Window {
    dataLayer: any;
  }
}

const get = () => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }
};

const push = (event: string, { ecommerce }: ecommerceObject) => {
  let dataLayer = get();

  let body: { event: string; ecommerce?: ecommerceProps } = {
    event,
  };

  if (typeof ecommerce === "object" && Object.keys(ecommerce).length) {
    body.ecommerce = ecommerce;
  }

  dataLayer.push(body);
};

const dataLayer = {
  get,
  push,
};

export default dataLayer;
